export function getBrowserTimeZone() {
    if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') {
        return '';
    }

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return typeof timeZone === 'string' ? timeZone : '';
}
